module.exports = __webpack_public_path__ + "img/mobile-id.20a43966.jpg";